<h1 class="title">Your User Profile</h1>
<h5>Manage your own details</h5>

<acabim-card *ngIf="!isLoading; else loadingView" class="card" [cardContent]="userform"
             cardHeading="Your Name and Contact Details"></acabim-card>

<ng-template #userform>
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="profile-form">

        <acabim-form-block labelWidth="10" [labelAlign]="'right'">

            <acabim-form-input-wrapper>
                <acabim-form-input-label>User Id</acabim-form-input-label>
                <acabim-form-input-content [note]="'for system internal use only'">
                    <input type="text" [value]="userGuid" readonly>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <!-- First Name -->
            <acabim-form-input-wrapper>
                <acabim-form-input-label>First Name</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="text" id="userFirstName" formControlName="userFirstName">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <!-- Family Name -->
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Family Name</acabim-form-input-label>
                <acabim-form-input-content>
                    <input type="text" id="userFamilyName" formControlName="userFamilyName">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <!-- Email -->
            <acabim-form-input-wrapper formArrayName="emails">
                <acabim-form-input-label>Email</acabim-form-input-label>
                <ng-container *ngFor="let emailControl of emailControls.controls; let i = index" [formGroupName]="i">
                    <acabim-form-input-content>
                        <div>
                            <input type="radio" formControlName="select_em" name="select_em" [value]=true disabled>
                            <input type="email" formControlName="input_em">
                        </div>
                        <div class="hanging">
                            <span *ngIf="emailControl.get('input_em')?.valid" class="cas-verify">Verified</span>
                            <p *ngIf="!emailControl.get('input_em')?.valid && emailControl.get('input_em')?.touched"
                               class="cas-waiting-verify">Waiting for verification</p>
                        </div>
                        <div class="hanging">
                            <p-dropdown [options]="userDataOptions" optionLabel="label" formControlName="type_em"></p-dropdown>
                            <button type="button" (click)="onDelete('email', i)">Delete</button>
                            <button (click)="onAdd('email')">Add</button>
                            <acabim-user-delete-data [title]="'Delete this Email'"
                                                     [data]="emailControls"
                                                     [type]="'email'"
                                                     [index]="index"
                                                     *ngIf="deleteAlert === 'email'"
                                                     (cancel)="onSubmitDeleteAlert($event,index,'emails')"></acabim-user-delete-data>
                        </div>
                    </acabim-form-input-content>
                </ng-container>
                <acabim-form-input-content>
                    <button *ngIf="0 === emailControls.controls.length" (click)="onAdd('email')">Add</button>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <!-- Phone -->
            <acabim-form-input-wrapper formArrayName="phones">
                <acabim-form-input-label>Phone</acabim-form-input-label>
                <ng-container *ngFor="let phoneControl of phoneControls.controls; let i = index" [formGroupName]="i">
                    <acabim-form-input-content>
                        <input type="radio" formControlName="select_ph" name="select_ph" [value]="true">
                        <div>
                            <input type="text" formControlName="input_ph">
                            <span *ngIf="phoneControl.get('input_ph')?.valid" class="cas-verify">Verified</span>
                            <p class="cas-waiting-verify" *ngIf="!phoneControl.get('input_ph')?.valid && phoneControl.get('input_ph')?.touched">
                                Waiting for verification</p>
                        </div>
                        <p-dropdown [options]="userDataOptions" optionLabel="label" formControlName="type_ph"></p-dropdown>
                        <acabim-button-negative (callback)="onDelete('phone',i)"></acabim-button-negative>
                        <acabim-button-positive (callback)="onAdd('phone')"></acabim-button-positive>
                        <acabim-user-add-data [title]="'Add a Phone Number'" [validator]="validatorPh"
                                              *ngIf="addAlert === 'phone'"
                                              (cancel)="onSubmitAddAlert($event,'phone')"></acabim-user-add-data>
                        <acabim-user-delete-data [title]="'Delete this phone number'"
                                                 [data]="phoneControls"
                                                 [index]="index"
                                                 [type]="'phone'"
                                                 *ngIf="deleteAlert === 'phone'"
                                                 (cancel)="onSubmitDeleteAlert($event,index,'phones')"></acabim-user-delete-data>
                    </acabim-form-input-content>
                </ng-container>
                <acabim-form-input-content>
                    <acabim-button-positive *ngIf="0 === phoneControls.controls.length" (callback)="onAdd('phone')"></acabim-button-positive>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>

            <!-- Address -->
            <acabim-form-input-wrapper formArrayName="addresses">
                <acabim-form-input-label>Address</acabim-form-input-label>
                <ng-container *ngFor="let addressControl of addressControls.controls; let i = index" [formGroupName]="i">
                    <acabim-form-input-content>
                        <input type="radio" formControlName="select_ad" name="select_ad" [value]=true>
                        <div>
                            <textarea rows="4" type="text" formControlName="input_ad"
                                      maxlength="120">
                            </textarea>
                            <span *ngIf="addressControl.get('input_ad')?.value != null"
                                  class="cas-character-count"> {{ addressControl.get('input_ad')?.value.length }}
                                / 120 </span>
                        </div>
                        <p-dropdown [options]="userDataOptions" optionLabel="label" formControlName="type_ad"></p-dropdown>
                        <acabim-button-negative (callback)="onDelete('address',i)"></acabim-button-negative>
                        <acabim-button-positive *ngIf="i === addressControls.length-1" (callback)="onAdd('address')"></acabim-button-positive>
                        <acabim-user-delete-data [title]="'Delete this address'"
                                                 [data]="addressControls"
                                                 [index]="index"
                                                 [type]="'address'"
                                                 *ngIf="deleteAlert === 'address'"
                                                 (cancel)="onSubmitDeleteAlert($event,index,'addresses')"></acabim-user-delete-data>
                    </acabim-form-input-content>
                </ng-container>
                <acabim-form-input-content>
                    <acabim-button-positive *ngIf="0 === addressControls.controls.length" (callback)="onAdd('address')"></acabim-button-positive>
                </acabim-form-input-content>

            </acabim-form-input-wrapper>

        </acabim-form-block>

        <div class="cas-action-buttons">
            <button type="submit" class="cas-button-action" [disabled]="!userForm.valid">UPDATE
            </button>
        </div>

    </form>
</ng-template>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-template [ngIf]="addAlert === 'address'">
    <acabim-modal
            title="Add an address"
            [display]="true"
            (status)="setModal($event)"
            [footer]="false"
            width="70vw">
        <acabim-user-add-data [title]="'Add an Address'"
                              [type]="'address'"
                              (cancel)="onSubmitAddAlert($event,'address')"></acabim-user-add-data>
    </acabim-modal>
</ng-template>


<ng-template [ngIf]="addAlert === 'email'">
    <acabim-modal
            title="Add an email address"
            [display]="true"
            (status)="setModal($event)"
            [footer]="false"
            width="70vw">
        <acabim-user-add-data [validator]="validatorEm"
                              [type]="'email'"
                              (cancel)="onSubmitAddAlert($event,'email')"></acabim-user-add-data>
    </acabim-modal>
</ng-template>

<ng-template [ngIf]="addAlert === 'phone'">

    <acabim-modal
            title="Add a phone number"
            [display]="true"
            (status)="setModal($event)"
            [footer]="false"
            width="70vw">
        <acabim-user-add-data [validator]="validatorPh"
                              [type]="'phone'"
                              (cancel)="onSubmitAddAlert($event,'phone')"></acabim-user-add-data>
    </acabim-modal>
</ng-template>

<p-toast position="center"></p-toast>
